import { gql } from "graphql-request";

export const PublicationFieldsFragment = gql`
  fragment PublicationFieldsFragment on PublicationSearchResult {
    publicationId
    name
    subdomain
  }
`;
